import React from "react";

function CandidateAccount() {
  return (
    <div className="p-8">
      <h1 className="text-h4 font-bold text-gray-900 mb-4">Account</h1>
      <p className="text-gray-600">Manage your account settings here.</p>
    </div>
  );
}

export default CandidateAccount;
